import { Observable, Subject } from 'rxjs';

export class TypedWorker<T, U> {
  protected _message$ = new Subject<U>();

  constructor(protected worker: Worker) {
    this.worker.onmessage = (data): void => {
      this._message$.next(data.data);
    };
  }

  post(message: T): void {
    this.worker.postMessage(message);
  }

  get(): Observable<U> {
    return this._message$.asObservable();
  }

  terminate(): void {
    this.worker.terminate();
    this._message$.unsubscribe();
  }
}
